import { useEffect, useState } from 'react';
import './styles/_main.scss';
import GeoPlanetViewer from 'pages/GeoPlanetViewer';
import VoxelPlanetViewer from 'pages/VoxelPlanetViewer';
import { Route, Routes, Navigate } from 'react-router-dom';
import Icons from 'Icons';
import Menu from 'components/Menu';
import AudioMenu from 'components/AudioMenu';
import Loading from 'components/Loading';
import { getModelPack, ModelPacks } from 'scripts/model-loader';
import Music from 'scripts/music';

function App() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>();

    useEffect(() => {
        load().catch(() => {
            setError('Failed to load, please try again later.')
        }).finally(() => setLoading(false))
    }, [])

    const load = async () => {
        new Music('assets/music.mp3');
        await getModelPack(ModelPacks[0]);
    }

    const render = () => {
        if (loading) {
            return (
                <div className="curtain"><Loading/></div>
            )
        }
        if (error) {
            return (
                <div className="curtain">
                    <div style={{margin: 'auto', stroke: 'white', textAlign: 'center'}}>
                        <svg width="64" height="64">
                            <use href="#ico"/>
                        </svg>
                        <div>{error}</div>
                    </div>
                </div>
            )
        }
        return (
            <>
                <Menu/>
                <AudioMenu/>
                <Routes>
                    <Route path="/ico" element={<GeoPlanetViewer/>} />
                    <Route path="/vox" element={<VoxelPlanetViewer/>} />
                    <Route path="/" element={<Navigate replace to="/ico"/>}/>
                    <Route path="*" element={<Navigate replace to="/ico"/>}/>
                </Routes>
            </>
        )
    }

    return (
        <div id="app-component">
            <Icons />
            {render()}
        </div>
    );
}

export default App;
